<template>
  <div class="list posRe">
    <template>
      <div class="swiper-container container-list">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in lists" :key="'lists'+index">
            <div class="clearFloat" :class="[client>0?'clearFloat'+client:'']">
              <template v-if="item&&item.length">
                <template v-for="(only,i) in item">
                  <only-list :class-name="'list'+state+'-'+index+'-'+i" :item="only" :lazy="lazy" :key="'only-item'+index+i"></only-list>
                </template>
              </template>
              <template v-if="total<params.limit">
                <template v-for="defaultIndex in (params.limit-total)">
                  <only-list default-bool="true" :class-name="'list'+state+'-'+index+'-'+(8-defaultIndex)" :item="defaultData" :lazy="lazy" :key="'only-item'+index+(8-defaultIndex)"></only-list>
                  </template>
              </template>

            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="top-right" v-if="total>params.limit">
      <div class="prev-list"><span class="icon-img"></span></div>
      <div class="next-list"><span class="icon-img"></span></div>
    </div>
  </div>
</template>

<script>
import onlyList from '@/components/onlyList'
export default {
  props: ['state', 'listUrl', 'client'],
  name: 'list',
  data () {
    return {
      listsAll: [],
      lists: [],
      lazy: {
        bool: true,
        elementClass: 'list-img'
      },
      total: 0,
      params: {
        page: 1,
        cityId: 0,
        limit: 8
      },
      defaultData:{
        address: '',
        cityName: '',
        good: "",
        id: 0,
        imgSrc: "",
        name: "",
        panoUrl: "",
        phone: "",
        share:'',
        x: "",
        y: "",
      }
    }
  },
  components: {
    onlyList: onlyList
  },
  created () {
    let that = this;
    that.clientFun();
    if (that.state === 2) {
      let c = JSON.parse(that.publicJs.decode(that.$route.query)) || {}
      that.params.cityId = c.cityId;
      that.params.typeId = c.typeId
    }
    if (that.state === 0) {
      that.httpData()
    }
  },
  mounted () {
  },
  methods: {
    clientFun: function () {
      var that = this;
      if (that.client === 1) {
        that.params.limit = 10
      } else if (that.client === 2) {
        that.params.limit = 6
      } else if (that.client === 3) {
        that.params.limit = 4
      } else {
        that.params.limit = 8
      }
    },
    newList: function (ArrayList, n) {
      if (ArrayList.length && n > 0) {
        let newArray = [];
        let num = Math.ceil(ArrayList.length / n);
        for (let i = 0; i < num; i++) {
          newArray.push(ArrayList.splice(0, n))
        }
        return newArray
      }
    },
    httpData: function () {
      let _that = this;
      _that.httpAjax.getAjax(_that.listUrl, _that.params).then(function (data) {
        if (data.code === 1) {
          if (_that.params.page === 1 && (!data.data || data.data.length <= 0)) {
            _that.$emit('empty', false)
            _that.lists=[{},{}]
          }
          let newData = JSON.parse(JSON.stringify(data.data));
          _that.total = data.total;
          while (_that.lists.length < Math.ceil(data.total / _that.params.limit)) { _that.lists.splice(0, 0, []) }
          _that.$set(_that.lists, _that.params.page - 1, newData);
          if (_that.params.page === 1) {
            _that.swiperFun()
          }
        }
      }, function (err) {
        console.log(err)
      })
    },
    swiperFun: function () {
      let _that = this
      _that.$nextTick(function () {
        // eslint-disable-next-line
        let swiper1 = new Swiper('.container-list', {
          slidesPerView: 1,
          spaceBetween: 5,
          lazy: {
            // loadPrevNext: true,
            elementClass: _that.lazy.elementClass
          },
          navigation: {
            nextEl: '.next-list',
            prevEl: '.prev-list'
          },
          observer: true,
          observeSlideChildren: true,
          observeParents: true,
          watchOverflow: true,
          on: {
            slideChange: function () {
              let i = this.activeIndex
              if (!_that.lists[i].length) {
                _that.params.page = (i + 1)
              }
            }
          }
        })
      })
    }
  },
  computed: {
  },
  watch: {
    params: {
      handler: function (a, b) {
        let that = this
        that.httpData()
      },
      deep: true
    },
    client: {
      handler: function (a, b) {
        let that = this
        if (a !== b) {
          that.lists = []
          that.params.page = 1
          that.clientFun()
          that.httpData()
        }
      },
      deep: true
    },
    '$route': {
      handler: function (a, b) {
        let that = this
        if (a !== b) {
          that.lists = []
          let c = JSON.parse(that.publicJs.decode(that.$route.query)) || {}
          that.params.cityId = c.cityId
          that.params.typeId = c.typeId
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .list{
    padding-bottom: 20px;
  }
  .list .swiper-slide>div{
    padding-top: 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .top-right{
    position: absolute;
    top:-44px;
    right: 0;
    display: flex;
    z-index: 55;
  }
  .top-right>div.swiper-button-disabled{
    opacity: 0.3;
  }
  .top-right>div{
    width: 30px;
    height: 24px;
  }
  .top-right>div>span{
    display: block;
    width: 100%;
    height: 100%;
    background-position: -309px -309px;
    background-color: #248DDF;
  }
  .top-right>div:hover span{
    -webkit-animation:bounceIn 0.8s;
    -o-animation:bounceIn 0.8s;
    animation:bounceIn 0.8s;
  }
  .top-right>div.swiper-button-disabled:hover span{
    -webkit-animation: none;
    -o-animation: none;
    animation: none;
    cursor: no-drop;
  }
  .top-right>.prev-list{
    width: 30px;
    height: 24px;
    /*background-color: #A3D2F7;*/
  }
  .top-right>.prev-list>span{
    background-position: -200px -309px;
  }
  .clearFloat>div{
    float: left;
    width: 25%;
  }
  .clearFloat1>div{
    width: 20%;
  }
  .clearFloat2>div{
    width: 33.33%;
  }
  .clearFloat3>div{
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/list.vue